<template>
  <FormLabel :text="text" :error="error" :tag="'div'">
    <input class="aoformfield aoformfield_datefield" :placeholder="placeholder" autocomplete="off"
           type="text"
           :disabled="$store.getters.loading"
           inputmode="numeric"
           v-maska="'##.##.####'"
           maxlength="10"
           :name="name"
           @focus="pickerShown"
           @blur="filledCheck"
           v-model="val">
    <button class="aoformlabel__datepick-summon-button" aria-label="Show datepicker" @click.stop.prevent="summonPicker">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect x="3" y="4" width="18" height="17" rx="2" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M7 16H8V17H7V16Z" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M11.5 16H12.5V17H11.5V16Z" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M16 16H17V17H16V16Z" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M7 12H8V13H7V12Z" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M11.5 12H12.5V13H11.5V12Z" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M16 12H17V13H16V12Z" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M8 2V6" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M16 2V6" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
    </button>
    <Transition name="fade">
      <DatePicker ref="picker" v-show="pickerShown" @click.stop.prevent v-model="pickedDate" v-click-outside="()=>pickerShown = false"/>
    </Transition>
  </FormLabel> 
</template>

<script>
import FormLabel from '@/components/FormLabel.vue'
import FormField from '@/mixins/FormField.vue'
import { maska } from 'maska'
import 'v-calendar/dist/style.css'
import { Calendar, DatePicker } from 'v-calendar'
import vClickOutside from 'click-outside-vue3'

export default {
  //eslint-disable-next-line
  components: { FormLabel, Calendar, DatePicker },
  mixins: [FormField],
  directives: { maska, clickOutside: vClickOutside.directive },
  props: {
    startAt: {type: String, default: '1990-01-01'},
    name: {type: String, required: true},
    modelValue: {type: String, default: ''},
    text: {type: String, required: true},
    placeholder: {type: String},
    validation: {type: Function, default: ()=>''},
    filled: {type: Function, default: (v)=>v.length==10?true:false}
  },
  data: ()=>({
    pickedDate: undefined,
    pickerShown: false,
    error: '',
    collector: {}
  }),
  methods:{
    summonPicker(){
      this.pickerShown = !this.pickerShown
      this.$nextTick(()=>{
        let split = this.modelValue.split('.')
        let condition = split.length < 3 || split[2].length < 4
        if (this.pickerShown && condition) 
          this.$el.querySelector('.vc-title').click()
      })
    },
    isValidDate(string){
      if (string[0] > 3 || string[0] == 3 && string[1] > 1)
        return false
      if (string[3] > 1 || string[3] == 1 && string[4] > 2)
        return false
      if (this.transformed) {
        let date = Date.parse(this.transformed)
        let day = this.transformed.split('/')[1]
        if (isNaN(date) || new Date(this.transformed).getDate() != day)
          return false
      }
      return true
    },
    filledCheck(){
      if (!this.filled(this.modelValue)) {
        this.error = "Заполните поле"
        this.collector[this.name] = false
      }
    }
  },
  computed:{
    val: {
      get () { return this.modelValue },
      set (value) { this.$emit('update:modelValue', value) },
    },
    transformed(){
      let string = this.val
      if (string.length == 10) {
        let transformed = string.split('.')
        let dd = transformed[0]
        transformed[0] = transformed [1]
        transformed[1] = dd
        return transformed.join('/')
      } 
      else
        return ''
    }
  },
  mounted(){
    this.collector = this.fieldsStatus
    if (this.collector)
      this.collector[this.name] = false
    let date = new Date(Date.parse(this.startAt))
    this.$refs.picker.move(date)
  },
  watch: {
    pickedDate(date){
      console.log(date)
      if (!date) return
      let textdate = (''+ date.getDate()).padStart(2,0) + '.' + ('' + (date.getMonth()+1)).padStart(2,0) + '.' + date.getFullYear()
      console.log(textdate)
      this.$emit('update:modelValue', textdate)
      this.pickerShown = false
    },
    modelValue(newVal){
      if (!this.isValidDate(newVal)) 
        this.error = 'Некорректная дата'
      else {
        this.error = ''
        if (this.transformed)
          this.error = this.validation(Date.parse(this.transformed))
      }
      
      if (this.error || !this.filled(newVal))
        this.collector[this.name] = false
      else
        this.collector[this.name] = true        
      this.filledCheck()
    }
  }
}
</script>

<style lang="sass">
.vc-container
  margin-left: auto
</style>